<template>
    <div>
        <div class="m-2">
            <b-row>
                <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                </b-col>
                <b-col cols="12" md="6">
                    <div class="d-flex align-items-center justify-content-end">
                        <b-form-input v-model="searchQuery" class="d-inline-block mr-1"
                            placeholder="Search..." />
                        <Addplugin @fetchPlugin="fetchPlugins" />
                        <!-- <EditpluginData :theme="editTheme"/> -->

                        <EditpluginData
                        :theme="editTheme"
                        @fetchPlugin="fetchPlugins"
                        @removeThemeData="removeThemeData"
                      />
                        <!-- <Addplugin :manage="isManageThemes" :token="bearerToken" @fetchThemes="fetchThemes" /> -->
                    </div>
                </b-col>
            </b-row>
        </div>
        <!-- <EditTheme :token="token" :theme="editTheme" @fetchThemes="fetchThemes" @removeThemeData="removeThemeData" /> -->
        <b-table :items="FilteredItems" responsive :fields="fields" class="mb-0" id="theme-table">
  <!-- Index -->
  <template #cell(index)="data">
    {{ data.index + 1 }}
  </template>

  <!-- Path -->
  <template #cell(path)="data">
    {{ data.item.path == null ? 'N/A' : data.item.path }}
  </template>

  <!-- Subjects Clickable -->
  <template #cell(subjects)="row">
    <a href="#" @click.prevent="openPluginDetails(row.item)">
      {{ row.item.subjects }}
    </a>
  </template>

  <!-- Topics Clickable -->
  <template #cell(topics)="row">
    <a href="#" @click.prevent="openPluginDetails(row.item)">
      {{ row.item.topics }}
    </a>
  </template>

  <!-- Levels Clickable -->
  <template #cell(levels)="row">
    <a href="#" @click.prevent="openPluginDetails(row.item)">
      {{ row.item.levels }}
    </a>
  </template>

  <!-- Actions -->
  <template #cell(action)="data">
    <div class="d-flex align-items-center">
      <b-dropdown variant="link" no-caret>
        <template #button-content>
          <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
        </template>
        <b-dropdown-item @click="editPluginData(data.item)">
          <div>
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">Edit</span>
          </div>
        </b-dropdown-item>
        <b-dropdown-item @click="deletePlugin(data.item._id, data.item.title)">
          <div>
            <b-spinner v-if="loading" small class="mr-1" />
            <feather-icon v-else icon="TrashIcon" />
            <span class="align-middle ml-50">Delete</span>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </template>
</b-table>


        <b-modal id="details-modal" ref="detailsModal" :title="'Name: ' + detailsTittle">
      <template v-if="topicDetails && topicDetails.length > 0">
        <div v-for="(classItem, classIndex) in topicDetails" :key="classIndex">
          <h2 class="text-center">Grade: {{ classItem.className }}</h2>
          <div v-for="(subject, subjectId) in classItem.subjects" :key="subjectId">
            <h3>Subject: {{ subject.subjectName }}</h3>
            <div v-for="(category, categoryId) in subject.categories" :key="categoryId">
              <h6>Topic: {{ category.categoryName }}</h6>
              <ul>
                <li v-for="(level, levelId) in category.levels" :key="levelId">
                  Level: {{ level.levelName }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <p>No records found.</p>
      </template>
    </b-modal>
    </div>
    
</template>

<!-- <template>
    <h2>
        ldsdkdnsdkndksndknkdsndnn
    </h2>
</template> -->


<script>
import {
  BFormInput,
  BButton,
  BTable,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BFormGroup,
  BSpinner,
  BCol,
  BCard,
  BRow,
} from "bootstrap-vue";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";


export default {
  components: {
    Addplugin: () => import("./AddPlugin.vue"),
    EditpluginData: () => import("./EditPlugin.vue"),
    BButton,
    BFormInput,
    BFormGroup,
    BTable,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BSpinner,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
  },
  data() {
    return {
      fields: [
        "index",
        { key: "title", label: "Title" },
        { key: "plugin", label: "Code" },
        { key: "platform", label: "PLATFORM" },
        { key: "path", label: "PATH" },
        { key: "subjects", label: "Subjects" },
        { key: "topics", label: "Topics" },
        { key: "levels", label: "Levels" },
        { key: "action", label: "ACTION" },
      ],
      searchQuery: "",
      themes1: [
        {
          name: { value: "MissingElements", text: "Missing Elements" },
          platform: "App",
          path: "/themes/theme-forest",
        },
        {
          name: { value: "DragAndDrop", text: "Drag And Drop" },
          platform: "App",
          path: "/themes/avada",
        },
        {
          name: { value: "EvaluateNumbers", text: "Evaluate Numbers" },
          platform: "App",
          path: "/themes/divi",
        },
        {
          name: { value: "NumberChart", text: "Number Chart" },
          platform: "Web",
          path: "/themes/enfold",
        },
        {
          name: {
            value: "MissingNumbersEvaluate",
            text: "Missing Numbers Evaluate",
          },
          platform: "App",
          path: "/themes/xstore",
        },
      ],
      loading: false,
      topicDetails: [],
      detailsTittle: "",
      editTheme: {},
      alertMessageToast: "",
      plugins: [],
    };
  },
  created() {
    this.fetchPlugins();
  },
  computed: {
    FilteredItems() {
      if (!this.searchQuery) {
        return this.plugins;
      }
      const query = this.searchQuery.toLowerCase();
      return this.plugins.filter((plugin) => {
        return (
          (plugin.title && plugin.title.toLowerCase().includes(query)) ||
          (plugin.plugin && plugin.plugin.toLowerCase().includes(query)) ||
          (plugin.platform && plugin.platform.toLowerCase().includes(query)) ||
          (plugin.path && plugin.path.toLowerCase().includes(query))
        );
      });
    },
  },
  methods: {
    openPluginDetails(plugin) {
    this.topicDetails = plugin.topicDetails || [];
    this.detailsTittle = plugin.title;
    this.$bvModal.show("details-modal");
    },
    fetchPlugin() {
            this.fetchPlugins()
        },

    async fetchPlugins() {
      this.loading = true;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/plugins/get-all`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("_t")}`,
            },
          }
        );

        if (response.data.success) {
          const plugins = response.data.data;

          const pluginDetailsPromises = plugins.map(async (plugin) => {
            try {
              const topicDetailsResp = await axios.get(
                `${process.env.VUE_APP_API_URL}/plugin-management/all`,
                {
                  params: { plugin: plugin.title },
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("_t")}`,
                  },
                }
              );

              if (topicDetailsResp.data.status === "success") {
                const totals = topicDetailsResp.data.total || {};
                const topicDetails = topicDetailsResp.data.topicDetails || [];

                plugin.subjects = totals.subjects || 0;
                plugin.topics = totals.categories || 0;
                plugin.levels = totals.levels || 0;
                plugin.topicDetails = topicDetails;
              } else {
                plugin.subjects = 0;
                plugin.topics = 0;
                plugin.levels = 0;
                plugin.topicDetails = [];
              }
            } catch (err) {
              plugin.subjects = 0;
              plugin.topics = 0;
              plugin.levels = 0;
              plugin.topicDetails = [];
            }

            return plugin;
          });

          this.plugins = await Promise.all(pluginDetailsPromises);
          this.showToast("success", "Plugins fetched successfully.");
        } else {
          this.showToast("danger", "Failed to fetch plugins.");
        }
      } catch (err) {
        this.showToast("danger", "Error fetching plugins or topic details.");
      } finally {
        this.loading = false;
      }
    },

    showToast(variant, message) {
      this.alertMessageToast = message;
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: this.alertMessageToast,
          variant,
        },
      });
    },

    removeThemeData() {
      this.editTheme = "";
    },

    fetchThemes() {
      this.$emit("fetchThemes");
    },
    editPluginData(theme) {
            this.editTheme = theme;
            this.$bvModal.show("edit-plugin-modal");
        },

    deletePlugin(id, name) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you want to delete plugin ${name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.delete(id);
        }
      });
    },

    async delete(id) {
      this.loading = true;
      try {
        const resp = await axios.delete(
          `${process.env.VUE_APP_API_URL}/plugin/delete-plugin/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("_t")}`,
            },
          }
        );

        if (resp.data.success) {
          this.showToast("success", resp.data.message);
          this.fetchPlugins();
        } else {
          this.showToast("danger", resp.data.message || "Failed to delete plugin");
        }
      } catch (error) {
        if (error.response) {
          this.showToast("danger", error.response.data.message || "An error occurred");
        } else if (error.request) {
          this.showToast("danger", "No response received from server. Please check your network.");
        } else {
          this.showToast("danger", "Error in request: " + error.message);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>



<style>
#theme-table th:first-child {
    width: 100px;
}

#theme-table th:last-child {
    width: 100px;
}

#theme-table td {
    word-break: break-all;
}
</style>
